import axios from 'axios';
import withDecrypt from '../../src/withDecrypt';

async function fetchAPI(query, { variables, preview } = {}) {
  return axios({
    method: 'post',
    url: process.env.NEXT_PUBLIC_API_URL,
    data: {
      query,
    },
    // headers: { 'accessToken': args[0] },
  })
    .then(resp => withDecrypt(resp.data))
    .catch(err => {
      console.log(err);
    });
}

export default async function getLatestPrice(tickers, preview) {
  const data = await fetchAPI(
    `
    query {
      getLatestPrice(tickers: "${JSON.stringify(tickers).replace(/\"/g, '\\"')}", price_type: "PRICE") {
        ticker
        short_name
        r
        p
      }
    }`,
    { preview }
  )
  return data
}
